module.exports = __webpack_public_path__ + "static/media/common_grandma_default.70cfb99b.png";